import script from "./MenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItem.vue?vue&type=script&setup=true&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=28e7a29a&lang=scss&scoped=true"

import exportComponent from "/Users/lgd_sunday/Desktop/langChain/wwzhidao-admin/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28e7a29a"]])

export default __exports__